import { IEmployeeDTO, IEmployeeViewDTO } from "../../libs/coreapi-dto/dirs/employee";
import CoreApiService from "../../system/api/coreApiService";
import { DictionaryDataProvider } from "./Common";

export class EmployeeDataProvider extends DictionaryDataProvider<IEmployeeViewDTO, IEmployeeDTO> {

    private _coreApiService: CoreApiService

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService
    }

    getDataRequest(): Promise<IDictionaryRequest<IEmployeeViewDTO, IEmployeeDTO>> {
        return this._coreApiService.employeeRequest
    }
}